module.exports = __webpack_public_path__ + "img/gry_8.77558361.png";